'use strict';

var ushimitsuMap = (function () {

  var myLatlng = new google.maps.LatLng(34.048811, 131.807366);
  var mapCenter = myLatlng;
  var mapCanvas = document.getElementById('mapCanvas');
  var mapOptions = {
    center: mapCenter,
    zoom: 13,
    scrollwheel: false,
    draggable: true,
    disableDefaultUI: true,
    zoomControl: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  };

  var styles = [
    {
      featureType: 'all',
      stylers: [
        { saturation: -100 }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        { hue: '#00ffee' },
        { saturation: 50 }
      ]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [
        { lightness: 100 },
        { visibility: 'simplified' }
      ]
    },{
      featureType: 'poi.business',
      elementType: 'labels',
      stylers: [
        { visibility: 'off' }
      ]
    }
  ];

  var map = new google.maps.Map(mapCanvas, mapOptions);

  var marker = new google.maps.Marker({
    position: myLatlng,
    map: map,
    title: 'ushimitsu'
  });
  marker.setOptions({
    icon: {
      url: 'http://ushimitsu.com/wp-content/uploads/2017/03/icon_gmap-marker.png',
      scaledSize: new google.maps.Size(45, 50)
    }
  });

  var contentString =
    '<div class="map-content">' +
    '<div class="site-notice">' +
    '</div>' +
    '<h2 class="map-content__heading">USHIMITSU</h2>' +
    '<p class="map-content__text">745-0027 山口県周南市糀町2-1</p>' +
    '<a class="map-content__link" href="https://goo.gl/maps/qLqDpZNtmRK2" target="_blank">Googleマップで見る</a>' +
    '</div>';

  var infowindow = new google.maps.InfoWindow({
    content: contentString,
    maxWidth: 300
  });

  return {
    init: function () {
      map.set('styles', styles);

      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map,marker);
      });
    }
  };

}());

ushimitsuMap.init();

